// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutPaystub_wrapper__JYK2h"};